import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const TransportQueueApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "TransportQueue" */ "./TransportQueueApp");
    return { default: namedExport.TransportQueueApp };
});

export const TransportQueue: TeamAppConfig = {
    title: "Transport Queue V3",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Real Time Delivery Queue Chart V3",
    team: "Transport",
    publicId: "Exchange\\Transport",
    owner: "TSZMFeatureCrew@microsoft.com",
    role: "*",
    tags: ["Transport", "Queue"],
    app: TransportQueueApp,
    path: "/TransportQueue"
};
